/**
 * An enum containing all the supported synthetic event
 * names supported by the Tooltip component
 *
 * @export
 * @enum {number}
 */
export var TooltipSyntheticEventNames;
(function (TooltipSyntheticEventNames) {
    TooltipSyntheticEventNames["Open"] = "tooltipOpen";
    TooltipSyntheticEventNames["Close"] = "tooltipClose";
})(TooltipSyntheticEventNames || (TooltipSyntheticEventNames = {}));
//# sourceMappingURL=TooltipSyntheticEventNames.js.map